module.exports = __webpack_public_path__ + "assets/img/placeholder.9db4ff7d.png";